import { createContext } from 'react';

const distribucionesContext = createContext();

export default distribucionesContext;
